import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDlYSFj3a_XyYNGIGDTfNhaz8V9fwfeBu8",
  authDomain: "tkbr-42f76.firebaseapp.com",
  projectId: "tkbr-42f76",
  storageBucket: "tkbr-42f76.appspot.com",
  messagingSenderId: "764010581748",
  appId: "1:764010581748:web:496432673ad1f1a4f8d8a1",
  measurementId: "G-7D791FWNK0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging and get a reference to the service
// Only initialize messaging if we're in the browser
export const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export default app;